"use client";

import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFoundationOfErflex() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237370" id="the-it-masters-philosophy" ref={sectionRef} className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
            <div className="container mx-auto px-4 md:px-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    
                    {}
                    <div className={`lg:col-span-5 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                        <div className="relative group">
                            {}
                            <div className="absolute -inset-4 bg-primary/5 rounded-md -z-10 hidden md:block transition-transform duration-700 group-hover:scale-[1.02] border border-border/50"></div>
                            
                            <AspectRatio ratio={3 / 4} className="bg-muted rounded-md overflow-hidden shadow-2xl">
                                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_architectural_precision.png" alt="IT Masters Infrastructure Architecture" className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700 brightness-75 group-hover:brightness-100" />
                            </AspectRatio>
                        </div>
                    </div>

                    {}
                    <div className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                        <div className="space-y-4">
                            <span className="text-sm font-mono tracking-widest uppercase text-primary">
                                The IT Masters Philosophy
                            </span>
                            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tighter leading-tight text-foreground">
                                Bridging the gap <br className="hidden md:block" />
                                <span className="text-muted-foreground italic font-serif opacity-80">between tech & efficiency.</span>
                            </h2>
                        </div>

                        <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-serif">
                            <p>
                                Since 2014, IT Masters has been the silent engine behind the digital transformation of leading enterprises. We don't just fix computers; we architect resilient, cost-effective infrastructure that scales with your ambition and secures your future.
                            </p>
                            <p>
                                Based in the UAE and backed by over a decade of hands-on expertise, we specialize in high-stakes virtualization and gold-standard cybersecurity. Our mission is to simplify the complex, ensuring your technology serves as a catalyst for growth rather than a barrier.
                            </p>
                        </div>

                        <div className="pt-8 border-t border-border mt-4 flex flex-col gap-4">
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_executive_seal.png" alt="IT Masters Corporate Seal" className="h-14 w-auto object-contain dark:invert opacity-60 self-start" />
                            <div>
                                <p className="font-default font-bold text-foreground text-lg tracking-tight">
                                    Precision Technology
                                </p>
                                <p className="text-sm text-primary font-mono uppercase tracking-widest mt-1">
                                    Proven Excellence Since 2014
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>;
}